// actions/reviewActions.js

import {
    FETCH_REVIEWS_REQUEST,
    FETCH_REVIEWS_SUCCESS,
    FETCH_REVIEWS_FAILURE,
  } from "./types";
  
  import { fetchReviews } from "../../services/reviewService"; // assuming you have a service for reviews
  
  // Action Creators
  export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
  
  export const fetchReviewsSuccess = (reviewsData) => ({
    type: FETCH_REVIEWS_SUCCESS,
    payload: reviewsData,
  });
  
  export const fetchReviewsFailure = (error) => ({
    type: FETCH_REVIEWS_FAILURE,
    payload: error,
  });
 
  export const fetchReviewsAction =
  ({
    mode = "all", 
    rating_type = null,
    driver_id = null,
    target_user_id = null,
    page = 1,
    size = 50,
  } = {}) =>
  async (dispatch) => {
    dispatch(fetchReviewsRequest());

    try {
      const result = await fetchReviews({
        mode,
        rating_type,
        driver_id,
        target_user_id,
        page,
        size,
      });

      // result = { items: [], pagination: {} }
      dispatch(fetchReviewsSuccess(result));
      return { success: true, data: result };
    } catch (error) {
      dispatch(fetchReviewsFailure(error?.message || "Failed to fetch reviews"));
      return { success: false, error: error?.message || "Failed to fetch reviews" };
    }
  };